import React from "react";
import "./Logo.css";

const Logo = () => {
  return (
    <div className="logo-container">
      <img className="logo" src="/logo.svg" alt="JugaYa logo" />
    </div>
  );
};

export default Logo;
